export default __webpack_public_path__ + "static/media/HFLA.b0ae8a62.png";